import { ImportPlanViews } from '../../../../../../../types/import.types.js';
import { FileUploadErrorView } from './FileUploadErrorView.jsx';
import { FileUploadView, type FileUploadViewProps } from './FileUploadView.jsx';
import { FileValidationView } from './FileValidationView.jsx';

type ImportModalBodyProps = FileUploadViewProps & {
  activeView: ImportPlanViews;
};

export const ImportModalBody = ({
  activeView,
  ...uploadProps
}: ImportModalBodyProps) => {
  if (activeView === ImportPlanViews.ERROR) {
    return <FileUploadErrorView />;
  }

  if (activeView === ImportPlanViews.PENDING) {
    return <FileValidationView />;
  }

  return <FileUploadView {...uploadProps} />;
};
